var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { AlertTriangleIcon, translate } from '@lucidlink/uicore';
import { FilespaceListItemTestIdFactory } from '../../interactions';
export const StatusErrorIcon = ({ filespaceId, ref }) => {
    return (_jsx(AlertTriangleIcon, { "aria-label": translate('Error'), color: "negative", "data-testid": FilespaceListItemTestIdFactory.getFilespaceListItemStatusIconTestId('error', filespaceId), ref: ref, size: "xsmall" }));
};
_react_refresh_temp_1 = StatusErrorIcon;
$RefreshReg$(_react_refresh_temp_1, "StatusErrorIcon");
